






















import BaseComponent from "@/asdcom/BaseComponent"
import { Component } from "vue-property-decorator";
import util from "@/lib/util";
import { IHeader } from '@/store/models/staff/IHeader';
import ReminderListComponent from"@/components/vcponlineok/staff-user/reminder-list-component.vue";
import { PagedAndSortedInputDto, PagedResultDtoOfVcClaimLogDto, IPagedAndSortedInputDto } from "@/asdcom/apiproxy/apiproxy.dto";
import bus from "@/components/vcponlineok/bus/bus.js";

@Component({
  components: {
    ReminderListComponent
  }
})
export default class Reminders extends BaseComponent {
  data = new PagedResultDtoOfVcClaimLogDto();

  created() {
    this.getReminders();
  }

  mounted() {
    bus.$on('refreshList', () => {
      this.getReminders();
    })
  }

  beforeDestroy() {
    bus.$off('refreshList');
  }

  async getReminders() {
    const sortCriteria: IPagedAndSortedInputDto = {
      maxResultCount: 1000,
      skipCount: 0,
      sorting: "dueDate"
    }
    this.data = await this.$appsvs.vcpOnlineOkStaff.retrieveOpenReminders(<PagedAndSortedInputDto>sortCriteria);
  }
}
